export interface FilterModel {
  id: string
  label: string
  placeholder?: string
  type: 'text' | 'select' | 'date'
  requiresDateRange?: boolean
  // Mensaje opcional cuando una fecha viola el minimo dinamico (ej: endDate < beginDate).
  dateMinErrorMessage?: string
  options?: {
    label: string
    value: string
  }[]
  minDate?: string
  maxDate?: string
}

export interface FilterResultModel {
  name: string
  value: string
}

export interface SearchParamsModel {
  search: string
  filters: FilterResultModel[]
}

export const convertFiltersToQuery = (
  filters?: FilterResultModel[],
): object | undefined => {
  return filters?.reduce((o, f) => Object.assign(o, { [f.name]: f.value }), {})
}
